import { createSlice } from '@reduxjs/toolkit';

export enum SearchPages {
    SEARCHED_CONTAINER = 'SearchedContainer',
    CHILD_CONTAINER = 'ChildContainer'
}

interface searchState {
    pageToRender: SearchPages
}

const initialState: searchState = {
    pageToRender: SearchPages.SEARCHED_CONTAINER
}

const searchSlice = createSlice({
    name: 'searchContainer',
    initialState,
    reducers: {
        setPageToRender: (state, action) => {
            state.pageToRender = action.payload;
        }
    }
});

export const { setPageToRender } = searchSlice.actions;
export default searchSlice.reducer;
